import React from 'react'
import { Helmet } from 'react-helmet'
import { withPrefix, useStaticQuery, graphql } from 'gatsby'

export default function ArSeo ({
  title,
  description,
  name,
  keywords = [],
  image = withPrefix('img/og-card.jpg'),
  imagePrefix,
  author,
  type = 'website',
  tag,
  path = '',
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            siteUrl
          }
        }
      }
    `
  )
  const { siteUrl: hostnameWithProtocol } = site.siteMetadata
  const url = hostnameWithProtocol + path
  const hostname = hostnameWithProtocol.split('://')[1]
  let imageAbsoluteURL

  if (imagePrefix) {
    imageAbsoluteURL = imagePrefix + image
  } else {
    imageAbsoluteURL = hostnameWithProtocol + image
  }

  return (
    <Helmet defer={false}>
      <title>{title}</title>
      <meta name="description" content={description}/>
      {keywords.length ? <meta name="keywords" content={keywords.join(',')}/> : null}
      <meta itemprop="name" content={name || description} />
      <meta itemprop="description" content={description} />
      <meta itemprop="image" content={imageAbsoluteURL} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:site" content="@artificiallabs" />
      <meta name="twitter:domain" content={hostname} />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:image" content={imageAbsoluteURL} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageAbsoluteURL} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="artificial." />
      <meta property="og:type" content={type} />
      {author && <meta property="og:author" content={author} />}

      <meta property="fb:admins" content="223891341125601" />

      {author && <meta name="article:author" content={author} />}
      {tag && <meta name="article:tag" content={tag} />}
    </Helmet>
  )
}
